/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Снять выделение',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Не удалось получить данные',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Нажмите, чтобы повторить попытку',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Загрузка…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Развернуть',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} из {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Совпадения не найдены',
  'paginated-picker.async-select.select.option.error-message': 'Не удалось получить данные',
  'paginated-picker.async-select.select.option.retry-message': 'Нажмите, чтобы повторить попытку',
  'paginated-picker.async-select.select.search-placeholder': 'Поиск',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Показать полный список',
};
